import React from "react";
import { styled } from "@mui/material/styles";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { Card, Box, Tooltip, Stack } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import axios from "../../utils/fvAxios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { getOrgId, getOrgType, setOnSiteOffsiteDetails, setOnSiteOffsiteId, getOnSiteOffsiteDetails, getOnSiteOffsiteId } from "../../utils/Token";
import Restore from "../../icons/Replay.svg";

import PropTypes from 'prop-types';

import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';

import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { log } from "mathjs";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.action.hover,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
        marginBottom: "20px",
    },
}));
const StyledTableCell1 = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#2a93db2e",
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
        marginBottom: "20px",
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const toastNotify = (message, isSuccess = true) => {
    if (isSuccess) {
        toast.success(message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    } else {
        toast.error(message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    }
};

function Row(props) {
    // const { row } = props;
    const { row, isExpanded, onRowClick, Spinner, setIsLoading, SelfCheckinDetails } = props;
    const [refreshDocs, setRefreshDocs] = React.useState([]);

    const [Search, setSearch] = React.useState(null);
    const [debouncedSearch, setDebouncedSearch] = React.useState(null);
    const [UnitSiteID, setUnitSiteID] = React.useState("");
    // const [OnSiteOffsiteDetails, setOnSiteOffsiteDetails] = React.useState(SelfCheckinDetails?.isEmployeeCurrentlyOnsite);
    // const [OnSiteOffsiteId, setOnSiteOffsiteId] = React.useState(SelfCheckinDetails?.siteId);

    const [UnitSiteName, setUnitSiteName] = React.useState("");

    const [Code, setCode] = useState("");
    const [showPrompt, setShowPrompt] = useState(false);

    const [Trg, setTrg] = useState(false);
    const [Dis, setDis] = useState(false);



    const RestoreData = () => {
        setIsLoading(true);
        axios
            .get("SystemUser/GetEmployeeOnsiteDetails")
            .then((resp) => {
                setOnSiteOffsiteDetails(resp?.data?.data?.isEmployeeCurrentlyOnsite);
                setOnSiteOffsiteId(resp?.data?.data?.siteId);
            })
            .catch((err) => {
                console.log(err);
            }).finally(() => {
                setTrg(!Trg);
                setIsLoading(false);
            });

    }

    useEffect(() => {
        if (Trg) {
            getOnSiteOffsiteDetails();
            getOnSiteOffsiteId();
        }
    }, [Trg]);

    const AccOpen = () => {
        onRowClick();
        setIsLoading(true);
        setSearch(null);
        setDebouncedSearch(null);
        setUnitSiteID(getOnSiteOffsiteId());
        setUnitSiteName("");
        axios
            .get("Prequalification/PQLocations?pqId=" + row?.prequalificationId
            )
            .then((resp) => {
                setRefreshDocs(resp?.data?.data?.filter((r) => r?.clientId == row?.clientId));
            })
            .catch((err) => {
                console.log(err);
            }).finally(() => {
                setIsLoading(false);
            })
    }


    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(Search);
        }, 500);
        return () => {
            clearTimeout(handler);
        };
    }, [Search]);

    const HandleSearch = (value) => {
        setSearch(value);
    };

    useEffect(() => {
        if (debouncedSearch || debouncedSearch == '') {
            setIsLoading(true);
            axios
                .get("Prequalification/PQLocations?pqId=" + row?.prequalificationId + "&sitename=" + debouncedSearch
                )
                .then((resp) => {
                    setRefreshDocs(resp?.data?.data?.filter((r) => r?.clientId == row?.clientId));
                })
                .catch((err) => {
                    console.log(err);
                }).finally(() => {
                    setIsLoading(false);
                })
        }
    }, [debouncedSearch]);

    const GetData = (val) => {
        if (row?.isComplianceCheckin == true) {
            setUnitSiteID(val?.clientBusinessUnitSiteID);
            setUnitSiteName(val?.businesUnitsiteName);
            setShowPrompt(true);
        } else {

            setIsLoading(true);
            axios
                .get("OnsiteOffsite/EmployeeSelfCheckin?clientid=" + row?.clientId + "&siteId=" + val?.clientBusinessUnitSiteID
                )
                .then((res) => {
                    if (res?.data?.responseCode == 100) {
                        setOnSiteOffsiteDetails(res?.data?.data?.isEmployeeCurrentlyOnsite);
                        setOnSiteOffsiteId(res?.data?.data?.siteId);
                        if (res?.data?.data?.status == "Failed") {
                            toastNotify(res?.data?.data?.status, false);
                        } else {
                            toastNotify(res?.data?.data?.status, true);
                        }
                    } else {
                        toastNotify(res?.data?.responseMessage, false);
                    }
                })
                .catch((err) => {
                    console.log(err);
                }).finally(() => {
                    setIsLoading(false);
                    setTrg(!Trg);
                })
        }
    }

    const Stop = (val) => {
        setIsLoading(true);
        axios
            .post("OnsiteOffsite/SelfCheckOut?clientid=" + row?.clientId + "&siteId=" + val
            )
            .then((res) => {
                if (res?.data?.responseCode == 100) {
                    setOnSiteOffsiteDetails(false);
                    setOnSiteOffsiteId(0);
                    toastNotify(res?.data?.data, true);
                } else {
                    if (res?.data?.data == "Failed") {
                        toastNotify(" No active check-in found for this site. Please click on the refresh icon", false);
                    } else {
                        toastNotify(res?.data?.responseMessage, false);
                    }

                }
            })
            .catch((err) => {
                console.log(err);
            }).finally(() => {
                setIsLoading(false);
                setTrg(!Trg);

            })
    }

    const SendRequest = () => {
        if (Code != "") {
            setIsLoading(true);
            setDis(true);
            axios
                .get("OnsiteOffsite/EmployeeSelfCheckin?clientid=" + row?.clientId + "&siteId=" + UnitSiteID + "&checkincode=" + Code
                )
                .then((res) => {
                    if (res?.data?.responseCode == 100) {
                        setOnSiteOffsiteDetails(res?.data?.data?.isEmployeeCurrentlyOnsite);
                        setOnSiteOffsiteId(res?.data?.data?.siteId);
                        //setTrg(!Trg);
                        if (res?.data?.data?.status == "Failed") {
                            toastNotify("Can't check-in to this site as all the mandatory trainings for this site is either not assigned to the user or not passed by the user.", false);
                        } else {
                            toastNotify(res?.data?.data?.status, true);
                            setShowPrompt(false);
                            setCode("");
                            setDis(false);
                        }
                    } else {
                        if (res?.data?.responseMessage == "Failed") {
                            toastNotify("Can't check-in to this site as all the mandatory trainings for this site is either not assigned to the user or not passed by the user.", false);
                            setCode("");
                        } else {
                            toastNotify(res?.data?.responseMessage, false);
                            setCode("");
                            setDis(false);
                        }

                    }
                })
                .catch((err) => {
                    console.log(err);
                }).finally(() => {
                    setIsLoading(false);
                    setTrg(!Trg);
                    setDis(false);
                    setCode("");
                })
        } else {
            toastNotify("Please enter the valid code", false);
            setShowPrompt(true);
            setDis(false);
            setCode("");
        }
    }

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme?.breakpoints?.down("md"));

    const groupedData = refreshDocs?.reduce((acc, curr) => {
        const clientKey = curr.clientName;
        const buKey = curr.businessUnitName;
        if (!acc[clientKey]) {
            acc[clientKey] = {};
        }
        if (!acc[clientKey][buKey]) {
            acc[clientKey][buKey] = [];
        }
        acc[clientKey][buKey].push(curr);
        return acc;
    }, {});

    return (
        <React.Fragment>
            <Dialog
                fullScreen={fullScreen}
                open={showPrompt}
                disableBackdropClick="true"
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        setShowPrompt(false)
                    }
                }}
            >
                <DialogContent
                    sx={{ padding: "40px 48px", overflowX: "hidden" }}
                    className="pb-1"
                >
                    <span className=''
                        onClick={() => {
                            setShowPrompt(false);
                            setCode("");
                            setDis(false);
                        }} style={{ color: "red", float: "right", cursor: "pointer" }}><CloseIcon /></span>
                    <DialogTitle
                        sx={{
                            textAlign: "center",
                            fontWeight: 500,
                            fontSize: 20,
                        }}
                    >
                        Site name: {UnitSiteName}
                    </DialogTitle>


                    <span style={{ color: "#3E4A62", fontSize: "18px" }} className="username-label mx-2 mt-2">
                        Site check-in code: <span className="red-color">*</span>
                    </span>
                    <TextField
                        className="form-control text-feild-custom mx-2"
                        placeholder='Enter site check-in code'
                        id="Enter site check-in code"
                        sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                            // width: "300px"
                            width: "450px"
                        }}
                        //variant="outlined"

                        size="small"
                        type="text"
                        value={Code}
                        required
                        onChange={(e) => setCode(e.target.value)}
                    />


                </DialogContent>
                <DialogActions className="pb-5">
                    <div className="login-help__buttonContainer d-flex gap-4 align-items-center px-5">
                        <Button
                            variant="contained"
                            className="login-help-button-cancel mx-2"
                            onClick={() => {
                                setShowPrompt(false);
                                setCode("");
                                setDis(false);
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            className="login-button-request mx-2"
                            onClick={SendRequest}
                            disabled={Dis}
                        >
                            Ok
                        </Button>
                    </div>
                </DialogActions>
                {/* <DialogContentText sx={{ textAlign: "center" }} >
                    <span>Site name: {UnitSiteName}</span> <span style={{ float: "right", color: "red", cursor: "pointer", }}>
                        <CloseIcon onClick={() => {
                            setShowPrompt(false);
                            setCode("");
                            setDis(false);
                        }} /></span>
                </DialogContentText>

                <DialogContent sx={{ padding: "48px 48px" }}>

                    <div style={{ textAlign: "center" }}>
                        <span style={{ fontSize: "29px" }}>Site check-in code: <span className="text-danger">  * </span ></span>
                        <br />

                        <TextField
                            className="mx-2"
                            placeholder='Enter site check-in code
'
                            sx={{
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                                fontFamily: "Arial, FontAwesome",
                                width: "300px"
                            }}
                            variant="outlined"
                            size="small"
                            value={Code}
                            onChange={(e) => setCode(e.target.value)}
                        />
                    </div>

                </DialogContent>
                <DialogActions >
                    <Button
                        onClick={() => {
                            setShowPrompt(false);
                            setCode("");
                            setDis(false);
                        }}
                        sx={{ minHeight: "39px", minWidth: "90px", margin: "auto" }}
                        className="shadow-none "
                        variant="contained"
                        color="primary"
                        autoFocus
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={SendRequest}
                        sx={{ minHeight: "39px", minWidth: "90px", margin: "auto" }}
                        className="shadow-none "
                        variant="contained"
                        color="primary"
                        autoFocus
                        disabled={Dis}
                    >
                        OK
                    </Button>
                </DialogActions> */}
            </Dialog>



            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                <TableCell sx={{ width: "5%" }}>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => AccOpen(row)}

                    >
                        {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell component="th" scope="row">
                    <Typography variant="h6" gutterBottom component="div">
                        {row.clientName}
                    </Typography>

                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                        <Box sx={{ margin: 1 }}>
                            <div className="mb-2">
                                <TextField
                                    placeholder='Search'
                                    sx={{
                                        "& legend": { display: "none" },
                                        "& fieldset": { top: 0 },
                                        fontFamily: "Arial, FontAwesome",
                                        width: "300px"
                                    }}
                                    variant="outlined"
                                    size="small"
                                    value={Search}
                                    onChange={(e) => HandleSearch(e.target.value)}
                                />
                            </div>
                            {refreshDocs?.length < 1 ?
                                <div hidden={Spinner}>
                                    <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" sx={{ padding: 2, marginTop: 4, width: "auto" }} className="text-center">
                                        <span style={{ color: "#667085" }}>No Result Found</span>
                                    </Box>
                                </div> :
                                <>
                                    {(Object.entries(groupedData)?.map(([clientName, clientData]) => (

                                        <AccordionDetails sx={{ padding: "0px" }}>
                                            <Box sx={{ backgroundColor: "#f8f9fa" }}>
                                                <TableContainer
                                                    component={Paper}
                                                    key={"ss" + clientName}
                                                    sx={{ borderBottom: 0 }}
                                                >
                                                    <Table aria-label="customized table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <StyledTableCell sx={{ width: "85%" }}>
                                                                    <Typography variant="h5" gutterBottom component="div">
                                                                        Site Name
                                                                    </Typography>
                                                                </StyledTableCell>
                                                                <StyledTableCell>
                                                                    &nbsp;
                                                                </StyledTableCell>

                                                            </TableRow>
                                                        </TableHead>

                                                        {Object.entries(clientData)?.map(([buName, buData]) => (
                                                            <>
                                                                <TableHead key={buName} hidden={(row?.isComplianceCheckin == true && buData?.some((r) => r?.isLocationTrainingsConfigured == true)) ? false : row?.isComplianceCheckin == false ? false : true} >

                                                                    <TableRow>
                                                                        <StyledTableCell1>
                                                                            <Typography variant="h6" gutterBottom component="div">

                                                                                {buName}
                                                                            </Typography>
                                                                        </StyledTableCell1>
                                                                        <StyledTableCell1>&nbsp;</StyledTableCell1>

                                                                    </TableRow>
                                                                </TableHead>

                                                                <TableBody>
                                                                    {buData?.map((r, index) => (
                                                                        <TableRow key={index} hidden={row?.isComplianceCheckin == true && r?.isLocationTrainingsConfigured == false}>
                                                                            <StyledTableCell sx={{ width: "85%" }}>
                                                                                {r?.businesUnitsiteName}
                                                                            </StyledTableCell>
                                                                            <StyledTableCell style={{ display: "flex" }}>

                                                                                {getOnSiteOffsiteDetails() == "false" && getOnSiteOffsiteId() == 0 ? (
                                                                                    // Display enabled Check-in buttons when the user is not checked in anywhere
                                                                                    <Button
                                                                                        key={r?.clientBusinessUnitSiteID}
                                                                                        variant="contained"
                                                                                        sx={{ padding: "inherit", textTransform: "capitalize", width: "max-content" }}
                                                                                        onClick={() => GetData(r)}
                                                                                    >
                                                                                        Check-in
                                                                                    </Button>
                                                                                ) : (
                                                                                    <>
                                                                                        {getOnSiteOffsiteId() == r?.clientBusinessUnitSiteID ? (<>

                                                                                            <Button
                                                                                                variant="contained"
                                                                                                sx={{ padding: "inherit", textTransform: "capitalize", width: "max-content" }}
                                                                                                onClick={() => Stop(r?.clientBusinessUnitSiteID)}
                                                                                            >
                                                                                                Check-out
                                                                                            </Button>
                                                                                            <Tooltip
                                                                                                placement="top"
                                                                                                title={"Refresh check-in/check-out status"}
                                                                                                arrow
                                                                                            >
                                                                                                <IconButton
                                                                                                    className="mx-5"
                                                                                                    aria-label="Restore"
                                                                                                    onClick={RestoreData}
                                                                                                >
                                                                                                    <img
                                                                                                        src={Restore}
                                                                                                        alt="Restoreicon"
                                                                                                        style={{ width: "25px" }}
                                                                                                    />
                                                                                                </IconButton>

                                                                                            </Tooltip>
                                                                                        </>

                                                                                        ) : (
                                                                                            <Button
                                                                                                key={r?.clientBusinessUnitSiteID}
                                                                                                disabled={true}
                                                                                                variant="contained"
                                                                                                sx={{ padding: "inherit", textTransform: "capitalize", width: "max-content" }}
                                                                                            >
                                                                                                Check-in
                                                                                            </Button>
                                                                                        )}
                                                                                    </>
                                                                                )}



                                                                            </StyledTableCell>

                                                                        </TableRow>
                                                                    ))}
                                                                </TableBody>
                                                            </>
                                                        ))}

                                                    </Table>
                                                </TableContainer>
                                            </Box>
                                        </AccordionDetails>

                                    )))}
                                </>
                            }
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default function CheckinCheckout() {



    const [isLoading, setIsLoading] = useState(false);
    const [response, setResponse] = useState([]);
    const [SelfCheckinDetails, setSelfCheckinDetails] = useState({});
    const OrgId = getOrgId();


    useEffect(() => {
        setIsLoading(true);
        axios
            .get("OnsiteOffsite/GetClientsForCheckin?vendorId=" + OrgId
            )
            .then((resp) => {
                setResponse(resp?.data?.data);
                setIsLoading(false);
            })
            .catch((err) => {
                console.log(err);
            }).finally(() => {
                setIsLoading(false);
            });

        axios
            .get("SystemUser/GetEmployeeOnsiteDetails")
            .then((resp) => {
                setSelfCheckinDetails(resp?.data?.data);
                setOnSiteOffsiteDetails(resp?.data?.data?.isEmployeeCurrentlyOnsite);
                setOnSiteOffsiteId(resp?.data?.data?.siteId)
            })
            .catch((err) => {
                console.log(err);
            }).finally(() => {
                setIsLoading(false);
            });



    }, []);


    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
    const { t } = useTranslation();
    const [expandedRow, setExpandedRow] = React.useState(null);
    const handleRowClick = (rowName) => {
        setExpandedRow((prev) => (prev === rowName ? null : rowName)); // Toggle row state
    };

    return (
        <div style={{ backgroundColor: "#fff" }}>
            <ToastContainer />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <Box sx={{ backgroundColor: "#fff", padding: "10px" }}>
                {response?.length == 0 ?
                    <div hidden={isLoading}>
                        <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" sx={{ padding: 2, marginTop: 4, width: "auto" }} className="text-center">
                            <span style={{ color: "#667085" }}>No site access</span>
                        </Box>
                    </div> :
                    <>
                        <TableContainer component={Paper}>
                            <Table aria-label="collapsible table">
                                <TableBody>

                                    {response?.map((r) => (

                                        <Row key={r.clientName} row={r}
                                            isExpanded={expandedRow == r.clientName}
                                            onRowClick={() => handleRowClick(r.clientName)}
                                            Spinner={isLoading}
                                            SelfCheckinDetails={SelfCheckinDetails}
                                            setIsLoading={setIsLoading} />

                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                }
            </Box>

        </div >
    );
}
